import { Language } from '../../types/common';

import * as ru from './static/img/ru.png';
import * as en from './static/img/en.png';
import * as es from './static/img/es.png';

export interface Option {
  code: Language;
  label: string;
  shortLabel: string;
  languageImg: string;
}
export const languages: Option[] = [
  { code: 'ru', label: 'Русский', shortLabel: 'RUS', languageImg: ru },
  { code: 'en', label: 'English', shortLabel: 'ENG', languageImg: en },
  { code: 'es', label: 'Español', shortLabel: 'ES', languageImg: es },
];
